import { apiClient } from "helpers/api_helper";

export const GetInwartReport = async (data: any) => {
    try {
        // const response = await apiClient.get(`api/v1/Report/GetStoreInwardStockReport?StoreId=21`, );
        const response = await apiClient.get(`api/v1/Report/GetStoreInwardStockReport`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
export const GetInwartReportDetails = async (data: any) => {
    try {
        // const response = await apiClient.get(`api/v1/Report/GetStoreInwardStockItemDetail?StoreId=21&MaterialType=silver&IsMemo=false`, );
        const response = await apiClient.get(`api/v1/Report/GetStoreInwardStockItemDetail`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};